import { Reveal, Overline, CtaButton, Hairline } from "./primitives";

export const NotSalesSection = () => (
  <section id="come-funziona" className="relative py-28 sm:py-36" data-testid="notsales-section">
    <Hairline className="absolute inset-x-0 top-0" />
    <div className="mx-auto max-w-4xl px-6 sm:px-8">
      <Reveal>
        <Overline>Come funziona</Overline>
        <h2 className="mt-6 font-serif text-3xl sm:text-5xl lg:text-6xl font-medium leading-[1.05] tracking-tight text-white">
          Non è una chiamata fatta per venderti qualcosa{" "}
          <span className="italic text-gold">a tutti i costi.</span>
        </h2>
      </Reveal>

      <Reveal delay={0.12}>
        <div className="mt-10 space-y-5 text-base sm:text-lg font-light leading-relaxed text-white/75">
          <p>La Mappa del Tempio non nasce come una chiamata commerciale aggressiva.</p>
          <p className="text-white">È prima di tutto una coaching cristiana di ascolto.</p>
          <p>
            Il nostro obiettivo iniziale è comprendere la tua situazione, ascoltare la tua storia
            e aiutarti a fare chiarezza.
          </p>
          <p>
            Alla fine dell'incontro, se riterremo davvero che possiamo esserti utili in modo più
            approfondito, potremo indicarti un eventuale percorso adatto a te. Ma non c'è alcun
            obbligo.
          </p>
          <p>
            La chiamata ha valore anche solo come momento di ascolto, confronto e prima direzione.
          </p>
        </div>
      </Reveal>

      <Reveal delay={0.2}>
        <div className="mt-14 rounded-2xl border-l-4 border-gold bg-white/[0.04] p-8 sm:p-10">
          <p className="font-serif text-2xl sm:text-4xl font-light leading-snug text-white">
            Prima di proporti una strada,{" "}
            <span className="italic text-gold">vogliamo ascoltare dove sei.</span>
          </p>
        </div>
      </Reveal>

      <Reveal delay={0.25} className="mt-10 flex justify-center">
        <CtaButton testId="notsales-cta" />
      </Reveal>
    </div>
  </section>
);
